/**
 * @fileoverview gRPC-Web generated client stub for atfai.console.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.21.12
// source: console.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as console_pb from './console_pb'; // proto import: "console.proto"


export class ConsoleServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreateAccount = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/CreateAccount',
    grpcWeb.MethodType.UNARY,
    console_pb.CreateAccountRequest,
    console_pb.CreateAccountResponse,
    (request: console_pb.CreateAccountRequest) => {
      return request.serializeBinary();
    },
    console_pb.CreateAccountResponse.deserializeBinary
  );

  createAccount(
    request: console_pb.CreateAccountRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.CreateAccountResponse>;

  createAccount(
    request: console_pb.CreateAccountRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.CreateAccountResponse) => void): grpcWeb.ClientReadableStream<console_pb.CreateAccountResponse>;

  createAccount(
    request: console_pb.CreateAccountRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.CreateAccountResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/CreateAccount',
        request,
        metadata || {},
        this.methodDescriptorCreateAccount,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/CreateAccount',
    request,
    metadata || {},
    this.methodDescriptorCreateAccount);
  }

  methodDescriptorGetAccount = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/GetAccount',
    grpcWeb.MethodType.UNARY,
    console_pb.GetAccountRequest,
    console_pb.GetAccountResponse,
    (request: console_pb.GetAccountRequest) => {
      return request.serializeBinary();
    },
    console_pb.GetAccountResponse.deserializeBinary
  );

  getAccount(
    request: console_pb.GetAccountRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.GetAccountResponse>;

  getAccount(
    request: console_pb.GetAccountRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.GetAccountResponse) => void): grpcWeb.ClientReadableStream<console_pb.GetAccountResponse>;

  getAccount(
    request: console_pb.GetAccountRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.GetAccountResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/GetAccount',
        request,
        metadata || {},
        this.methodDescriptorGetAccount,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/GetAccount',
    request,
    metadata || {},
    this.methodDescriptorGetAccount);
  }

  methodDescriptorListAccounts = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListAccounts',
    grpcWeb.MethodType.UNARY,
    console_pb.ListAccountsRequest,
    console_pb.ListAccountsResponse,
    (request: console_pb.ListAccountsRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListAccountsResponse.deserializeBinary
  );

  listAccounts(
    request: console_pb.ListAccountsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListAccountsResponse>;

  listAccounts(
    request: console_pb.ListAccountsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListAccountsResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListAccountsResponse>;

  listAccounts(
    request: console_pb.ListAccountsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListAccountsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListAccounts',
        request,
        metadata || {},
        this.methodDescriptorListAccounts,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListAccounts',
    request,
    metadata || {},
    this.methodDescriptorListAccounts);
  }

  methodDescriptorUpdateAccount = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/UpdateAccount',
    grpcWeb.MethodType.UNARY,
    console_pb.UpdateAccountRequest,
    console_pb.UpdateAccountResponse,
    (request: console_pb.UpdateAccountRequest) => {
      return request.serializeBinary();
    },
    console_pb.UpdateAccountResponse.deserializeBinary
  );

  updateAccount(
    request: console_pb.UpdateAccountRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.UpdateAccountResponse>;

  updateAccount(
    request: console_pb.UpdateAccountRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.UpdateAccountResponse) => void): grpcWeb.ClientReadableStream<console_pb.UpdateAccountResponse>;

  updateAccount(
    request: console_pb.UpdateAccountRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.UpdateAccountResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/UpdateAccount',
        request,
        metadata || {},
        this.methodDescriptorUpdateAccount,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/UpdateAccount',
    request,
    metadata || {},
    this.methodDescriptorUpdateAccount);
  }

  methodDescriptorDeleteAccount = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/DeleteAccount',
    grpcWeb.MethodType.UNARY,
    console_pb.DeleteAccountRequest,
    console_pb.DeleteAccountResponse,
    (request: console_pb.DeleteAccountRequest) => {
      return request.serializeBinary();
    },
    console_pb.DeleteAccountResponse.deserializeBinary
  );

  deleteAccount(
    request: console_pb.DeleteAccountRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.DeleteAccountResponse>;

  deleteAccount(
    request: console_pb.DeleteAccountRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.DeleteAccountResponse) => void): grpcWeb.ClientReadableStream<console_pb.DeleteAccountResponse>;

  deleteAccount(
    request: console_pb.DeleteAccountRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.DeleteAccountResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/DeleteAccount',
        request,
        metadata || {},
        this.methodDescriptorDeleteAccount,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/DeleteAccount',
    request,
    metadata || {},
    this.methodDescriptorDeleteAccount);
  }

  methodDescriptorCreateOrg = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/CreateOrg',
    grpcWeb.MethodType.UNARY,
    console_pb.CreateOrgRequest,
    console_pb.CreateOrgResponse,
    (request: console_pb.CreateOrgRequest) => {
      return request.serializeBinary();
    },
    console_pb.CreateOrgResponse.deserializeBinary
  );

  createOrg(
    request: console_pb.CreateOrgRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.CreateOrgResponse>;

  createOrg(
    request: console_pb.CreateOrgRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.CreateOrgResponse) => void): grpcWeb.ClientReadableStream<console_pb.CreateOrgResponse>;

  createOrg(
    request: console_pb.CreateOrgRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.CreateOrgResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/CreateOrg',
        request,
        metadata || {},
        this.methodDescriptorCreateOrg,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/CreateOrg',
    request,
    metadata || {},
    this.methodDescriptorCreateOrg);
  }

  methodDescriptorGetOrg = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/GetOrg',
    grpcWeb.MethodType.UNARY,
    console_pb.GetOrgRequest,
    console_pb.GetOrgResponse,
    (request: console_pb.GetOrgRequest) => {
      return request.serializeBinary();
    },
    console_pb.GetOrgResponse.deserializeBinary
  );

  getOrg(
    request: console_pb.GetOrgRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.GetOrgResponse>;

  getOrg(
    request: console_pb.GetOrgRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.GetOrgResponse) => void): grpcWeb.ClientReadableStream<console_pb.GetOrgResponse>;

  getOrg(
    request: console_pb.GetOrgRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.GetOrgResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/GetOrg',
        request,
        metadata || {},
        this.methodDescriptorGetOrg,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/GetOrg',
    request,
    metadata || {},
    this.methodDescriptorGetOrg);
  }

  methodDescriptorListOrgs = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListOrgs',
    grpcWeb.MethodType.UNARY,
    console_pb.ListOrgsRequest,
    console_pb.ListOrgsResponse,
    (request: console_pb.ListOrgsRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListOrgsResponse.deserializeBinary
  );

  listOrgs(
    request: console_pb.ListOrgsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListOrgsResponse>;

  listOrgs(
    request: console_pb.ListOrgsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListOrgsResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListOrgsResponse>;

  listOrgs(
    request: console_pb.ListOrgsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListOrgsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListOrgs',
        request,
        metadata || {},
        this.methodDescriptorListOrgs,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListOrgs',
    request,
    metadata || {},
    this.methodDescriptorListOrgs);
  }

  methodDescriptorUpdateOrg = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/UpdateOrg',
    grpcWeb.MethodType.UNARY,
    console_pb.UpdateOrgRequest,
    console_pb.UpdateOrgResponse,
    (request: console_pb.UpdateOrgRequest) => {
      return request.serializeBinary();
    },
    console_pb.UpdateOrgResponse.deserializeBinary
  );

  updateOrg(
    request: console_pb.UpdateOrgRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.UpdateOrgResponse>;

  updateOrg(
    request: console_pb.UpdateOrgRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.UpdateOrgResponse) => void): grpcWeb.ClientReadableStream<console_pb.UpdateOrgResponse>;

  updateOrg(
    request: console_pb.UpdateOrgRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.UpdateOrgResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/UpdateOrg',
        request,
        metadata || {},
        this.methodDescriptorUpdateOrg,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/UpdateOrg',
    request,
    metadata || {},
    this.methodDescriptorUpdateOrg);
  }

  methodDescriptorDeleteOrg = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/DeleteOrg',
    grpcWeb.MethodType.UNARY,
    console_pb.DeleteOrgRequest,
    console_pb.DeleteOrgResponse,
    (request: console_pb.DeleteOrgRequest) => {
      return request.serializeBinary();
    },
    console_pb.DeleteOrgResponse.deserializeBinary
  );

  deleteOrg(
    request: console_pb.DeleteOrgRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.DeleteOrgResponse>;

  deleteOrg(
    request: console_pb.DeleteOrgRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.DeleteOrgResponse) => void): grpcWeb.ClientReadableStream<console_pb.DeleteOrgResponse>;

  deleteOrg(
    request: console_pb.DeleteOrgRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.DeleteOrgResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/DeleteOrg',
        request,
        metadata || {},
        this.methodDescriptorDeleteOrg,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/DeleteOrg',
    request,
    metadata || {},
    this.methodDescriptorDeleteOrg);
  }

  methodDescriptorRestoreOrg = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/RestoreOrg',
    grpcWeb.MethodType.UNARY,
    console_pb.RestoreOrgRequest,
    console_pb.RestoreOrgResponse,
    (request: console_pb.RestoreOrgRequest) => {
      return request.serializeBinary();
    },
    console_pb.RestoreOrgResponse.deserializeBinary
  );

  restoreOrg(
    request: console_pb.RestoreOrgRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.RestoreOrgResponse>;

  restoreOrg(
    request: console_pb.RestoreOrgRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.RestoreOrgResponse) => void): grpcWeb.ClientReadableStream<console_pb.RestoreOrgResponse>;

  restoreOrg(
    request: console_pb.RestoreOrgRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.RestoreOrgResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/RestoreOrg',
        request,
        metadata || {},
        this.methodDescriptorRestoreOrg,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/RestoreOrg',
    request,
    metadata || {},
    this.methodDescriptorRestoreOrg);
  }

  methodDescriptorListPurgeEligibleOrgs = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListPurgeEligibleOrgs',
    grpcWeb.MethodType.UNARY,
    console_pb.ListPurgeEligibleOrgsRequest,
    console_pb.ListPurgeEligibleOrgsResponse,
    (request: console_pb.ListPurgeEligibleOrgsRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListPurgeEligibleOrgsResponse.deserializeBinary
  );

  listPurgeEligibleOrgs(
    request: console_pb.ListPurgeEligibleOrgsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListPurgeEligibleOrgsResponse>;

  listPurgeEligibleOrgs(
    request: console_pb.ListPurgeEligibleOrgsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListPurgeEligibleOrgsResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListPurgeEligibleOrgsResponse>;

  listPurgeEligibleOrgs(
    request: console_pb.ListPurgeEligibleOrgsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListPurgeEligibleOrgsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListPurgeEligibleOrgs',
        request,
        metadata || {},
        this.methodDescriptorListPurgeEligibleOrgs,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListPurgeEligibleOrgs',
    request,
    metadata || {},
    this.methodDescriptorListPurgeEligibleOrgs);
  }

  methodDescriptorMarkOrgPurged = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/MarkOrgPurged',
    grpcWeb.MethodType.UNARY,
    console_pb.MarkOrgPurgedRequest,
    console_pb.MarkOrgPurgedResponse,
    (request: console_pb.MarkOrgPurgedRequest) => {
      return request.serializeBinary();
    },
    console_pb.MarkOrgPurgedResponse.deserializeBinary
  );

  markOrgPurged(
    request: console_pb.MarkOrgPurgedRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.MarkOrgPurgedResponse>;

  markOrgPurged(
    request: console_pb.MarkOrgPurgedRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.MarkOrgPurgedResponse) => void): grpcWeb.ClientReadableStream<console_pb.MarkOrgPurgedResponse>;

  markOrgPurged(
    request: console_pb.MarkOrgPurgedRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.MarkOrgPurgedResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/MarkOrgPurged',
        request,
        metadata || {},
        this.methodDescriptorMarkOrgPurged,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/MarkOrgPurged',
    request,
    metadata || {},
    this.methodDescriptorMarkOrgPurged);
  }

  methodDescriptorMintSignup = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/MintSignup',
    grpcWeb.MethodType.UNARY,
    console_pb.MintSignupRequest,
    console_pb.MintSignupResponse,
    (request: console_pb.MintSignupRequest) => {
      return request.serializeBinary();
    },
    console_pb.MintSignupResponse.deserializeBinary
  );

  mintSignup(
    request: console_pb.MintSignupRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.MintSignupResponse>;

  mintSignup(
    request: console_pb.MintSignupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.MintSignupResponse) => void): grpcWeb.ClientReadableStream<console_pb.MintSignupResponse>;

  mintSignup(
    request: console_pb.MintSignupRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.MintSignupResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/MintSignup',
        request,
        metadata || {},
        this.methodDescriptorMintSignup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/MintSignup',
    request,
    metadata || {},
    this.methodDescriptorMintSignup);
  }

  methodDescriptorSubmitInstanceSupportRequest = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/SubmitInstanceSupportRequest',
    grpcWeb.MethodType.UNARY,
    console_pb.SubmitInstanceSupportRequestRequest,
    console_pb.SubmitInstanceSupportRequestResponse,
    (request: console_pb.SubmitInstanceSupportRequestRequest) => {
      return request.serializeBinary();
    },
    console_pb.SubmitInstanceSupportRequestResponse.deserializeBinary
  );

  submitInstanceSupportRequest(
    request: console_pb.SubmitInstanceSupportRequestRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.SubmitInstanceSupportRequestResponse>;

  submitInstanceSupportRequest(
    request: console_pb.SubmitInstanceSupportRequestRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.SubmitInstanceSupportRequestResponse) => void): grpcWeb.ClientReadableStream<console_pb.SubmitInstanceSupportRequestResponse>;

  submitInstanceSupportRequest(
    request: console_pb.SubmitInstanceSupportRequestRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.SubmitInstanceSupportRequestResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/SubmitInstanceSupportRequest',
        request,
        metadata || {},
        this.methodDescriptorSubmitInstanceSupportRequest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/SubmitInstanceSupportRequest',
    request,
    metadata || {},
    this.methodDescriptorSubmitInstanceSupportRequest);
  }

  methodDescriptorRegisterInstance = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/RegisterInstance',
    grpcWeb.MethodType.UNARY,
    console_pb.RegisterInstanceRequest,
    console_pb.RegisterInstanceResponse,
    (request: console_pb.RegisterInstanceRequest) => {
      return request.serializeBinary();
    },
    console_pb.RegisterInstanceResponse.deserializeBinary
  );

  registerInstance(
    request: console_pb.RegisterInstanceRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.RegisterInstanceResponse>;

  registerInstance(
    request: console_pb.RegisterInstanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.RegisterInstanceResponse) => void): grpcWeb.ClientReadableStream<console_pb.RegisterInstanceResponse>;

  registerInstance(
    request: console_pb.RegisterInstanceRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.RegisterInstanceResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/RegisterInstance',
        request,
        metadata || {},
        this.methodDescriptorRegisterInstance,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/RegisterInstance',
    request,
    metadata || {},
    this.methodDescriptorRegisterInstance);
  }

  methodDescriptorInstanceHeartbeat = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/InstanceHeartbeat',
    grpcWeb.MethodType.UNARY,
    console_pb.InstanceHeartbeatRequest,
    console_pb.InstanceHeartbeatResponse,
    (request: console_pb.InstanceHeartbeatRequest) => {
      return request.serializeBinary();
    },
    console_pb.InstanceHeartbeatResponse.deserializeBinary
  );

  instanceHeartbeat(
    request: console_pb.InstanceHeartbeatRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.InstanceHeartbeatResponse>;

  instanceHeartbeat(
    request: console_pb.InstanceHeartbeatRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.InstanceHeartbeatResponse) => void): grpcWeb.ClientReadableStream<console_pb.InstanceHeartbeatResponse>;

  instanceHeartbeat(
    request: console_pb.InstanceHeartbeatRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.InstanceHeartbeatResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/InstanceHeartbeat',
        request,
        metadata || {},
        this.methodDescriptorInstanceHeartbeat,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/InstanceHeartbeat',
    request,
    metadata || {},
    this.methodDescriptorInstanceHeartbeat);
  }

  methodDescriptorGetInstance = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/GetInstance',
    grpcWeb.MethodType.UNARY,
    console_pb.GetInstanceRequest,
    console_pb.GetInstanceResponse,
    (request: console_pb.GetInstanceRequest) => {
      return request.serializeBinary();
    },
    console_pb.GetInstanceResponse.deserializeBinary
  );

  getInstance(
    request: console_pb.GetInstanceRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.GetInstanceResponse>;

  getInstance(
    request: console_pb.GetInstanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.GetInstanceResponse) => void): grpcWeb.ClientReadableStream<console_pb.GetInstanceResponse>;

  getInstance(
    request: console_pb.GetInstanceRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.GetInstanceResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/GetInstance',
        request,
        metadata || {},
        this.methodDescriptorGetInstance,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/GetInstance',
    request,
    metadata || {},
    this.methodDescriptorGetInstance);
  }

  methodDescriptorListInstances = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListInstances',
    grpcWeb.MethodType.UNARY,
    console_pb.ListInstancesRequest,
    console_pb.ListInstancesResponse,
    (request: console_pb.ListInstancesRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListInstancesResponse.deserializeBinary
  );

  listInstances(
    request: console_pb.ListInstancesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListInstancesResponse>;

  listInstances(
    request: console_pb.ListInstancesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListInstancesResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListInstancesResponse>;

  listInstances(
    request: console_pb.ListInstancesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListInstancesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListInstances',
        request,
        metadata || {},
        this.methodDescriptorListInstances,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListInstances',
    request,
    metadata || {},
    this.methodDescriptorListInstances);
  }

  methodDescriptorUpdateInstance = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/UpdateInstance',
    grpcWeb.MethodType.UNARY,
    console_pb.UpdateInstanceRequest,
    console_pb.UpdateInstanceResponse,
    (request: console_pb.UpdateInstanceRequest) => {
      return request.serializeBinary();
    },
    console_pb.UpdateInstanceResponse.deserializeBinary
  );

  updateInstance(
    request: console_pb.UpdateInstanceRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.UpdateInstanceResponse>;

  updateInstance(
    request: console_pb.UpdateInstanceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.UpdateInstanceResponse) => void): grpcWeb.ClientReadableStream<console_pb.UpdateInstanceResponse>;

  updateInstance(
    request: console_pb.UpdateInstanceRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.UpdateInstanceResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/UpdateInstance',
        request,
        metadata || {},
        this.methodDescriptorUpdateInstance,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/UpdateInstance',
    request,
    metadata || {},
    this.methodDescriptorUpdateInstance);
  }

  methodDescriptorMintInstanceToken = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/MintInstanceToken',
    grpcWeb.MethodType.UNARY,
    console_pb.MintInstanceTokenRequest,
    console_pb.MintInstanceTokenResponse,
    (request: console_pb.MintInstanceTokenRequest) => {
      return request.serializeBinary();
    },
    console_pb.MintInstanceTokenResponse.deserializeBinary
  );

  mintInstanceToken(
    request: console_pb.MintInstanceTokenRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.MintInstanceTokenResponse>;

  mintInstanceToken(
    request: console_pb.MintInstanceTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.MintInstanceTokenResponse) => void): grpcWeb.ClientReadableStream<console_pb.MintInstanceTokenResponse>;

  mintInstanceToken(
    request: console_pb.MintInstanceTokenRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.MintInstanceTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/MintInstanceToken',
        request,
        metadata || {},
        this.methodDescriptorMintInstanceToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/MintInstanceToken',
    request,
    metadata || {},
    this.methodDescriptorMintInstanceToken);
  }

  methodDescriptorIssueLicense = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/IssueLicense',
    grpcWeb.MethodType.UNARY,
    console_pb.IssueLicenseRequest,
    console_pb.IssueLicenseResponse,
    (request: console_pb.IssueLicenseRequest) => {
      return request.serializeBinary();
    },
    console_pb.IssueLicenseResponse.deserializeBinary
  );

  issueLicense(
    request: console_pb.IssueLicenseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.IssueLicenseResponse>;

  issueLicense(
    request: console_pb.IssueLicenseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.IssueLicenseResponse) => void): grpcWeb.ClientReadableStream<console_pb.IssueLicenseResponse>;

  issueLicense(
    request: console_pb.IssueLicenseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.IssueLicenseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/IssueLicense',
        request,
        metadata || {},
        this.methodDescriptorIssueLicense,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/IssueLicense',
    request,
    metadata || {},
    this.methodDescriptorIssueLicense);
  }

  methodDescriptorAssignLicense = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/AssignLicense',
    grpcWeb.MethodType.UNARY,
    console_pb.AssignLicenseRequest,
    console_pb.AssignLicenseResponse,
    (request: console_pb.AssignLicenseRequest) => {
      return request.serializeBinary();
    },
    console_pb.AssignLicenseResponse.deserializeBinary
  );

  assignLicense(
    request: console_pb.AssignLicenseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.AssignLicenseResponse>;

  assignLicense(
    request: console_pb.AssignLicenseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.AssignLicenseResponse) => void): grpcWeb.ClientReadableStream<console_pb.AssignLicenseResponse>;

  assignLicense(
    request: console_pb.AssignLicenseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.AssignLicenseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/AssignLicense',
        request,
        metadata || {},
        this.methodDescriptorAssignLicense,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/AssignLicense',
    request,
    metadata || {},
    this.methodDescriptorAssignLicense);
  }

  methodDescriptorSuspendLicense = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/SuspendLicense',
    grpcWeb.MethodType.UNARY,
    console_pb.SuspendLicenseRequest,
    console_pb.SuspendLicenseResponse,
    (request: console_pb.SuspendLicenseRequest) => {
      return request.serializeBinary();
    },
    console_pb.SuspendLicenseResponse.deserializeBinary
  );

  suspendLicense(
    request: console_pb.SuspendLicenseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.SuspendLicenseResponse>;

  suspendLicense(
    request: console_pb.SuspendLicenseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.SuspendLicenseResponse) => void): grpcWeb.ClientReadableStream<console_pb.SuspendLicenseResponse>;

  suspendLicense(
    request: console_pb.SuspendLicenseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.SuspendLicenseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/SuspendLicense',
        request,
        metadata || {},
        this.methodDescriptorSuspendLicense,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/SuspendLicense',
    request,
    metadata || {},
    this.methodDescriptorSuspendLicense);
  }

  methodDescriptorResumeLicense = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ResumeLicense',
    grpcWeb.MethodType.UNARY,
    console_pb.ResumeLicenseRequest,
    console_pb.ResumeLicenseResponse,
    (request: console_pb.ResumeLicenseRequest) => {
      return request.serializeBinary();
    },
    console_pb.ResumeLicenseResponse.deserializeBinary
  );

  resumeLicense(
    request: console_pb.ResumeLicenseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ResumeLicenseResponse>;

  resumeLicense(
    request: console_pb.ResumeLicenseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ResumeLicenseResponse) => void): grpcWeb.ClientReadableStream<console_pb.ResumeLicenseResponse>;

  resumeLicense(
    request: console_pb.ResumeLicenseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ResumeLicenseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ResumeLicense',
        request,
        metadata || {},
        this.methodDescriptorResumeLicense,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ResumeLicense',
    request,
    metadata || {},
    this.methodDescriptorResumeLicense);
  }

  methodDescriptorRevokeLicense = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/RevokeLicense',
    grpcWeb.MethodType.UNARY,
    console_pb.RevokeLicenseRequest,
    console_pb.RevokeLicenseResponse,
    (request: console_pb.RevokeLicenseRequest) => {
      return request.serializeBinary();
    },
    console_pb.RevokeLicenseResponse.deserializeBinary
  );

  revokeLicense(
    request: console_pb.RevokeLicenseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.RevokeLicenseResponse>;

  revokeLicense(
    request: console_pb.RevokeLicenseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.RevokeLicenseResponse) => void): grpcWeb.ClientReadableStream<console_pb.RevokeLicenseResponse>;

  revokeLicense(
    request: console_pb.RevokeLicenseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.RevokeLicenseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/RevokeLicense',
        request,
        metadata || {},
        this.methodDescriptorRevokeLicense,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/RevokeLicense',
    request,
    metadata || {},
    this.methodDescriptorRevokeLicense);
  }

  methodDescriptorGetLicense = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/GetLicense',
    grpcWeb.MethodType.UNARY,
    console_pb.GetLicenseRequest,
    console_pb.GetLicenseResponse,
    (request: console_pb.GetLicenseRequest) => {
      return request.serializeBinary();
    },
    console_pb.GetLicenseResponse.deserializeBinary
  );

  getLicense(
    request: console_pb.GetLicenseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.GetLicenseResponse>;

  getLicense(
    request: console_pb.GetLicenseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.GetLicenseResponse) => void): grpcWeb.ClientReadableStream<console_pb.GetLicenseResponse>;

  getLicense(
    request: console_pb.GetLicenseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.GetLicenseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/GetLicense',
        request,
        metadata || {},
        this.methodDescriptorGetLicense,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/GetLicense',
    request,
    metadata || {},
    this.methodDescriptorGetLicense);
  }

  methodDescriptorListLicenses = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListLicenses',
    grpcWeb.MethodType.UNARY,
    console_pb.ListLicensesRequest,
    console_pb.ListLicensesResponse,
    (request: console_pb.ListLicensesRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListLicensesResponse.deserializeBinary
  );

  listLicenses(
    request: console_pb.ListLicensesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListLicensesResponse>;

  listLicenses(
    request: console_pb.ListLicensesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListLicensesResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListLicensesResponse>;

  listLicenses(
    request: console_pb.ListLicensesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListLicensesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListLicenses',
        request,
        metadata || {},
        this.methodDescriptorListLicenses,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListLicenses',
    request,
    metadata || {},
    this.methodDescriptorListLicenses);
  }

  methodDescriptorIngestUsageEvents = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/IngestUsageEvents',
    grpcWeb.MethodType.UNARY,
    console_pb.IngestUsageEventsRequest,
    console_pb.IngestUsageEventsResponse,
    (request: console_pb.IngestUsageEventsRequest) => {
      return request.serializeBinary();
    },
    console_pb.IngestUsageEventsResponse.deserializeBinary
  );

  ingestUsageEvents(
    request: console_pb.IngestUsageEventsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.IngestUsageEventsResponse>;

  ingestUsageEvents(
    request: console_pb.IngestUsageEventsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.IngestUsageEventsResponse) => void): grpcWeb.ClientReadableStream<console_pb.IngestUsageEventsResponse>;

  ingestUsageEvents(
    request: console_pb.IngestUsageEventsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.IngestUsageEventsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/IngestUsageEvents',
        request,
        metadata || {},
        this.methodDescriptorIngestUsageEvents,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/IngestUsageEvents',
    request,
    metadata || {},
    this.methodDescriptorIngestUsageEvents);
  }

  methodDescriptorCreateOperator = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/CreateOperator',
    grpcWeb.MethodType.UNARY,
    console_pb.CreateOperatorRequest,
    console_pb.CreateOperatorResponse,
    (request: console_pb.CreateOperatorRequest) => {
      return request.serializeBinary();
    },
    console_pb.CreateOperatorResponse.deserializeBinary
  );

  createOperator(
    request: console_pb.CreateOperatorRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.CreateOperatorResponse>;

  createOperator(
    request: console_pb.CreateOperatorRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.CreateOperatorResponse) => void): grpcWeb.ClientReadableStream<console_pb.CreateOperatorResponse>;

  createOperator(
    request: console_pb.CreateOperatorRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.CreateOperatorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/CreateOperator',
        request,
        metadata || {},
        this.methodDescriptorCreateOperator,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/CreateOperator',
    request,
    metadata || {},
    this.methodDescriptorCreateOperator);
  }

  methodDescriptorListOperators = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListOperators',
    grpcWeb.MethodType.UNARY,
    console_pb.ListOperatorsRequest,
    console_pb.ListOperatorsResponse,
    (request: console_pb.ListOperatorsRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListOperatorsResponse.deserializeBinary
  );

  listOperators(
    request: console_pb.ListOperatorsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListOperatorsResponse>;

  listOperators(
    request: console_pb.ListOperatorsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListOperatorsResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListOperatorsResponse>;

  listOperators(
    request: console_pb.ListOperatorsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListOperatorsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListOperators',
        request,
        metadata || {},
        this.methodDescriptorListOperators,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListOperators',
    request,
    metadata || {},
    this.methodDescriptorListOperators);
  }

  methodDescriptorCreateApiKey = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/CreateApiKey',
    grpcWeb.MethodType.UNARY,
    console_pb.CreateApiKeyRequest,
    console_pb.CreateApiKeyResponse,
    (request: console_pb.CreateApiKeyRequest) => {
      return request.serializeBinary();
    },
    console_pb.CreateApiKeyResponse.deserializeBinary
  );

  createApiKey(
    request: console_pb.CreateApiKeyRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.CreateApiKeyResponse>;

  createApiKey(
    request: console_pb.CreateApiKeyRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.CreateApiKeyResponse) => void): grpcWeb.ClientReadableStream<console_pb.CreateApiKeyResponse>;

  createApiKey(
    request: console_pb.CreateApiKeyRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.CreateApiKeyResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/CreateApiKey',
        request,
        metadata || {},
        this.methodDescriptorCreateApiKey,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/CreateApiKey',
    request,
    metadata || {},
    this.methodDescriptorCreateApiKey);
  }

  methodDescriptorRevokeApiKey = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/RevokeApiKey',
    grpcWeb.MethodType.UNARY,
    console_pb.RevokeApiKeyRequest,
    console_pb.RevokeApiKeyResponse,
    (request: console_pb.RevokeApiKeyRequest) => {
      return request.serializeBinary();
    },
    console_pb.RevokeApiKeyResponse.deserializeBinary
  );

  revokeApiKey(
    request: console_pb.RevokeApiKeyRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.RevokeApiKeyResponse>;

  revokeApiKey(
    request: console_pb.RevokeApiKeyRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.RevokeApiKeyResponse) => void): grpcWeb.ClientReadableStream<console_pb.RevokeApiKeyResponse>;

  revokeApiKey(
    request: console_pb.RevokeApiKeyRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.RevokeApiKeyResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/RevokeApiKey',
        request,
        metadata || {},
        this.methodDescriptorRevokeApiKey,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/RevokeApiKey',
    request,
    metadata || {},
    this.methodDescriptorRevokeApiKey);
  }

  methodDescriptorDisableOperator = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/DisableOperator',
    grpcWeb.MethodType.UNARY,
    console_pb.DisableOperatorRequest,
    console_pb.DisableOperatorResponse,
    (request: console_pb.DisableOperatorRequest) => {
      return request.serializeBinary();
    },
    console_pb.DisableOperatorResponse.deserializeBinary
  );

  disableOperator(
    request: console_pb.DisableOperatorRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.DisableOperatorResponse>;

  disableOperator(
    request: console_pb.DisableOperatorRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.DisableOperatorResponse) => void): grpcWeb.ClientReadableStream<console_pb.DisableOperatorResponse>;

  disableOperator(
    request: console_pb.DisableOperatorRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.DisableOperatorResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/DisableOperator',
        request,
        metadata || {},
        this.methodDescriptorDisableOperator,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/DisableOperator',
    request,
    metadata || {},
    this.methodDescriptorDisableOperator);
  }

  methodDescriptorSetOperatorPassword = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/SetOperatorPassword',
    grpcWeb.MethodType.UNARY,
    console_pb.SetOperatorPasswordRequest,
    console_pb.SetOperatorPasswordResponse,
    (request: console_pb.SetOperatorPasswordRequest) => {
      return request.serializeBinary();
    },
    console_pb.SetOperatorPasswordResponse.deserializeBinary
  );

  setOperatorPassword(
    request: console_pb.SetOperatorPasswordRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.SetOperatorPasswordResponse>;

  setOperatorPassword(
    request: console_pb.SetOperatorPasswordRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.SetOperatorPasswordResponse) => void): grpcWeb.ClientReadableStream<console_pb.SetOperatorPasswordResponse>;

  setOperatorPassword(
    request: console_pb.SetOperatorPasswordRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.SetOperatorPasswordResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/SetOperatorPassword',
        request,
        metadata || {},
        this.methodDescriptorSetOperatorPassword,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/SetOperatorPassword',
    request,
    metadata || {},
    this.methodDescriptorSetOperatorPassword);
  }

  methodDescriptorWhoAmI = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/WhoAmI',
    grpcWeb.MethodType.UNARY,
    console_pb.WhoAmIRequest,
    console_pb.WhoAmIResponse,
    (request: console_pb.WhoAmIRequest) => {
      return request.serializeBinary();
    },
    console_pb.WhoAmIResponse.deserializeBinary
  );

  whoAmI(
    request: console_pb.WhoAmIRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.WhoAmIResponse>;

  whoAmI(
    request: console_pb.WhoAmIRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.WhoAmIResponse) => void): grpcWeb.ClientReadableStream<console_pb.WhoAmIResponse>;

  whoAmI(
    request: console_pb.WhoAmIRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.WhoAmIResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/WhoAmI',
        request,
        metadata || {},
        this.methodDescriptorWhoAmI,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/WhoAmI',
    request,
    metadata || {},
    this.methodDescriptorWhoAmI);
  }

  methodDescriptorListUsageEvents = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListUsageEvents',
    grpcWeb.MethodType.UNARY,
    console_pb.ListUsageEventsRequest,
    console_pb.ListUsageEventsResponse,
    (request: console_pb.ListUsageEventsRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListUsageEventsResponse.deserializeBinary
  );

  listUsageEvents(
    request: console_pb.ListUsageEventsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListUsageEventsResponse>;

  listUsageEvents(
    request: console_pb.ListUsageEventsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListUsageEventsResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListUsageEventsResponse>;

  listUsageEvents(
    request: console_pb.ListUsageEventsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListUsageEventsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListUsageEvents',
        request,
        metadata || {},
        this.methodDescriptorListUsageEvents,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListUsageEvents',
    request,
    metadata || {},
    this.methodDescriptorListUsageEvents);
  }

  methodDescriptorListApiKeys = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListApiKeys',
    grpcWeb.MethodType.UNARY,
    console_pb.ListApiKeysRequest,
    console_pb.ListApiKeysResponse,
    (request: console_pb.ListApiKeysRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListApiKeysResponse.deserializeBinary
  );

  listApiKeys(
    request: console_pb.ListApiKeysRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListApiKeysResponse>;

  listApiKeys(
    request: console_pb.ListApiKeysRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListApiKeysResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListApiKeysResponse>;

  listApiKeys(
    request: console_pb.ListApiKeysRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListApiKeysResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListApiKeys',
        request,
        metadata || {},
        this.methodDescriptorListApiKeys,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListApiKeys',
    request,
    metadata || {},
    this.methodDescriptorListApiKeys);
  }

  methodDescriptorCreateContract = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/CreateContract',
    grpcWeb.MethodType.UNARY,
    console_pb.CreateContractRequest,
    console_pb.CreateContractResponse,
    (request: console_pb.CreateContractRequest) => {
      return request.serializeBinary();
    },
    console_pb.CreateContractResponse.deserializeBinary
  );

  createContract(
    request: console_pb.CreateContractRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.CreateContractResponse>;

  createContract(
    request: console_pb.CreateContractRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.CreateContractResponse) => void): grpcWeb.ClientReadableStream<console_pb.CreateContractResponse>;

  createContract(
    request: console_pb.CreateContractRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.CreateContractResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/CreateContract',
        request,
        metadata || {},
        this.methodDescriptorCreateContract,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/CreateContract',
    request,
    metadata || {},
    this.methodDescriptorCreateContract);
  }

  methodDescriptorGetContractStatus = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/GetContractStatus',
    grpcWeb.MethodType.UNARY,
    console_pb.GetContractStatusRequest,
    console_pb.GetContractStatusResponse,
    (request: console_pb.GetContractStatusRequest) => {
      return request.serializeBinary();
    },
    console_pb.GetContractStatusResponse.deserializeBinary
  );

  getContractStatus(
    request: console_pb.GetContractStatusRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.GetContractStatusResponse>;

  getContractStatus(
    request: console_pb.GetContractStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.GetContractStatusResponse) => void): grpcWeb.ClientReadableStream<console_pb.GetContractStatusResponse>;

  getContractStatus(
    request: console_pb.GetContractStatusRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.GetContractStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/GetContractStatus',
        request,
        metadata || {},
        this.methodDescriptorGetContractStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/GetContractStatus',
    request,
    metadata || {},
    this.methodDescriptorGetContractStatus);
  }

  methodDescriptorCancelContract = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/CancelContract',
    grpcWeb.MethodType.UNARY,
    console_pb.CancelContractRequest,
    console_pb.CancelContractResponse,
    (request: console_pb.CancelContractRequest) => {
      return request.serializeBinary();
    },
    console_pb.CancelContractResponse.deserializeBinary
  );

  cancelContract(
    request: console_pb.CancelContractRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.CancelContractResponse>;

  cancelContract(
    request: console_pb.CancelContractRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.CancelContractResponse) => void): grpcWeb.ClientReadableStream<console_pb.CancelContractResponse>;

  cancelContract(
    request: console_pb.CancelContractRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.CancelContractResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/CancelContract',
        request,
        metadata || {},
        this.methodDescriptorCancelContract,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/CancelContract',
    request,
    metadata || {},
    this.methodDescriptorCancelContract);
  }

  methodDescriptorListLicenseHealthAlerts = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListLicenseHealthAlerts',
    grpcWeb.MethodType.UNARY,
    console_pb.ListLicenseHealthAlertsRequest,
    console_pb.ListLicenseHealthAlertsResponse,
    (request: console_pb.ListLicenseHealthAlertsRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListLicenseHealthAlertsResponse.deserializeBinary
  );

  listLicenseHealthAlerts(
    request: console_pb.ListLicenseHealthAlertsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListLicenseHealthAlertsResponse>;

  listLicenseHealthAlerts(
    request: console_pb.ListLicenseHealthAlertsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListLicenseHealthAlertsResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListLicenseHealthAlertsResponse>;

  listLicenseHealthAlerts(
    request: console_pb.ListLicenseHealthAlertsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListLicenseHealthAlertsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListLicenseHealthAlerts',
        request,
        metadata || {},
        this.methodDescriptorListLicenseHealthAlerts,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListLicenseHealthAlerts',
    request,
    metadata || {},
    this.methodDescriptorListLicenseHealthAlerts);
  }

  methodDescriptorGetOrgUsageRollup = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/GetOrgUsageRollup',
    grpcWeb.MethodType.UNARY,
    console_pb.GetOrgUsageRollupRequest,
    console_pb.GetOrgUsageRollupResponse,
    (request: console_pb.GetOrgUsageRollupRequest) => {
      return request.serializeBinary();
    },
    console_pb.GetOrgUsageRollupResponse.deserializeBinary
  );

  getOrgUsageRollup(
    request: console_pb.GetOrgUsageRollupRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.GetOrgUsageRollupResponse>;

  getOrgUsageRollup(
    request: console_pb.GetOrgUsageRollupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.GetOrgUsageRollupResponse) => void): grpcWeb.ClientReadableStream<console_pb.GetOrgUsageRollupResponse>;

  getOrgUsageRollup(
    request: console_pb.GetOrgUsageRollupRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.GetOrgUsageRollupResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/GetOrgUsageRollup',
        request,
        metadata || {},
        this.methodDescriptorGetOrgUsageRollup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/GetOrgUsageRollup',
    request,
    metadata || {},
    this.methodDescriptorGetOrgUsageRollup);
  }

  methodDescriptorGetRevenueOverview = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/GetRevenueOverview',
    grpcWeb.MethodType.UNARY,
    console_pb.GetRevenueOverviewRequest,
    console_pb.GetRevenueOverviewResponse,
    (request: console_pb.GetRevenueOverviewRequest) => {
      return request.serializeBinary();
    },
    console_pb.GetRevenueOverviewResponse.deserializeBinary
  );

  getRevenueOverview(
    request: console_pb.GetRevenueOverviewRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.GetRevenueOverviewResponse>;

  getRevenueOverview(
    request: console_pb.GetRevenueOverviewRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.GetRevenueOverviewResponse) => void): grpcWeb.ClientReadableStream<console_pb.GetRevenueOverviewResponse>;

  getRevenueOverview(
    request: console_pb.GetRevenueOverviewRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.GetRevenueOverviewResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/GetRevenueOverview',
        request,
        metadata || {},
        this.methodDescriptorGetRevenueOverview,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/GetRevenueOverview',
    request,
    metadata || {},
    this.methodDescriptorGetRevenueOverview);
  }

  methodDescriptorListMyLicenses = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListMyLicenses',
    grpcWeb.MethodType.UNARY,
    console_pb.ListMyLicensesRequest,
    console_pb.ListMyLicensesResponse,
    (request: console_pb.ListMyLicensesRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListMyLicensesResponse.deserializeBinary
  );

  listMyLicenses(
    request: console_pb.ListMyLicensesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListMyLicensesResponse>;

  listMyLicenses(
    request: console_pb.ListMyLicensesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListMyLicensesResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListMyLicensesResponse>;

  listMyLicenses(
    request: console_pb.ListMyLicensesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListMyLicensesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListMyLicenses',
        request,
        metadata || {},
        this.methodDescriptorListMyLicenses,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListMyLicenses',
    request,
    metadata || {},
    this.methodDescriptorListMyLicenses);
  }

  methodDescriptorGetMyLicense = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/GetMyLicense',
    grpcWeb.MethodType.UNARY,
    console_pb.GetMyLicenseRequest,
    console_pb.GetMyLicenseResponse,
    (request: console_pb.GetMyLicenseRequest) => {
      return request.serializeBinary();
    },
    console_pb.GetMyLicenseResponse.deserializeBinary
  );

  getMyLicense(
    request: console_pb.GetMyLicenseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.GetMyLicenseResponse>;

  getMyLicense(
    request: console_pb.GetMyLicenseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.GetMyLicenseResponse) => void): grpcWeb.ClientReadableStream<console_pb.GetMyLicenseResponse>;

  getMyLicense(
    request: console_pb.GetMyLicenseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.GetMyLicenseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/GetMyLicense',
        request,
        metadata || {},
        this.methodDescriptorGetMyLicense,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/GetMyLicense',
    request,
    metadata || {},
    this.methodDescriptorGetMyLicense);
  }

  methodDescriptorDownloadMyLicense = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/DownloadMyLicense',
    grpcWeb.MethodType.UNARY,
    console_pb.DownloadMyLicenseRequest,
    console_pb.DownloadMyLicenseResponse,
    (request: console_pb.DownloadMyLicenseRequest) => {
      return request.serializeBinary();
    },
    console_pb.DownloadMyLicenseResponse.deserializeBinary
  );

  downloadMyLicense(
    request: console_pb.DownloadMyLicenseRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.DownloadMyLicenseResponse>;

  downloadMyLicense(
    request: console_pb.DownloadMyLicenseRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.DownloadMyLicenseResponse) => void): grpcWeb.ClientReadableStream<console_pb.DownloadMyLicenseResponse>;

  downloadMyLicense(
    request: console_pb.DownloadMyLicenseRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.DownloadMyLicenseResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/DownloadMyLicense',
        request,
        metadata || {},
        this.methodDescriptorDownloadMyLicense,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/DownloadMyLicense',
    request,
    metadata || {},
    this.methodDescriptorDownloadMyLicense);
  }

  methodDescriptorListMyUsageEvents = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListMyUsageEvents',
    grpcWeb.MethodType.UNARY,
    console_pb.ListMyUsageEventsRequest,
    console_pb.ListMyUsageEventsResponse,
    (request: console_pb.ListMyUsageEventsRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListMyUsageEventsResponse.deserializeBinary
  );

  listMyUsageEvents(
    request: console_pb.ListMyUsageEventsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListMyUsageEventsResponse>;

  listMyUsageEvents(
    request: console_pb.ListMyUsageEventsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListMyUsageEventsResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListMyUsageEventsResponse>;

  listMyUsageEvents(
    request: console_pb.ListMyUsageEventsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListMyUsageEventsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListMyUsageEvents',
        request,
        metadata || {},
        this.methodDescriptorListMyUsageEvents,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListMyUsageEvents',
    request,
    metadata || {},
    this.methodDescriptorListMyUsageEvents);
  }

  methodDescriptorGetMyContractStatus = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/GetMyContractStatus',
    grpcWeb.MethodType.UNARY,
    console_pb.GetMyContractStatusRequest,
    console_pb.GetMyContractStatusResponse,
    (request: console_pb.GetMyContractStatusRequest) => {
      return request.serializeBinary();
    },
    console_pb.GetMyContractStatusResponse.deserializeBinary
  );

  getMyContractStatus(
    request: console_pb.GetMyContractStatusRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.GetMyContractStatusResponse>;

  getMyContractStatus(
    request: console_pb.GetMyContractStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.GetMyContractStatusResponse) => void): grpcWeb.ClientReadableStream<console_pb.GetMyContractStatusResponse>;

  getMyContractStatus(
    request: console_pb.GetMyContractStatusRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.GetMyContractStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/GetMyContractStatus',
        request,
        metadata || {},
        this.methodDescriptorGetMyContractStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/GetMyContractStatus',
    request,
    metadata || {},
    this.methodDescriptorGetMyContractStatus);
  }

  methodDescriptorChangeMyPassword = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ChangeMyPassword',
    grpcWeb.MethodType.UNARY,
    console_pb.ChangeMyPasswordRequest,
    console_pb.ChangeMyPasswordResponse,
    (request: console_pb.ChangeMyPasswordRequest) => {
      return request.serializeBinary();
    },
    console_pb.ChangeMyPasswordResponse.deserializeBinary
  );

  changeMyPassword(
    request: console_pb.ChangeMyPasswordRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ChangeMyPasswordResponse>;

  changeMyPassword(
    request: console_pb.ChangeMyPasswordRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ChangeMyPasswordResponse) => void): grpcWeb.ClientReadableStream<console_pb.ChangeMyPasswordResponse>;

  changeMyPassword(
    request: console_pb.ChangeMyPasswordRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ChangeMyPasswordResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ChangeMyPassword',
        request,
        metadata || {},
        this.methodDescriptorChangeMyPassword,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ChangeMyPassword',
    request,
    metadata || {},
    this.methodDescriptorChangeMyPassword);
  }

  methodDescriptorInviteMember = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/InviteMember',
    grpcWeb.MethodType.UNARY,
    console_pb.InviteMemberRequest,
    console_pb.InviteMemberResponse,
    (request: console_pb.InviteMemberRequest) => {
      return request.serializeBinary();
    },
    console_pb.InviteMemberResponse.deserializeBinary
  );

  inviteMember(
    request: console_pb.InviteMemberRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.InviteMemberResponse>;

  inviteMember(
    request: console_pb.InviteMemberRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.InviteMemberResponse) => void): grpcWeb.ClientReadableStream<console_pb.InviteMemberResponse>;

  inviteMember(
    request: console_pb.InviteMemberRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.InviteMemberResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/InviteMember',
        request,
        metadata || {},
        this.methodDescriptorInviteMember,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/InviteMember',
    request,
    metadata || {},
    this.methodDescriptorInviteMember);
  }

  methodDescriptorInviteFirstCustomer = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/InviteFirstCustomer',
    grpcWeb.MethodType.UNARY,
    console_pb.InviteFirstCustomerRequest,
    console_pb.InviteFirstCustomerResponse,
    (request: console_pb.InviteFirstCustomerRequest) => {
      return request.serializeBinary();
    },
    console_pb.InviteFirstCustomerResponse.deserializeBinary
  );

  inviteFirstCustomer(
    request: console_pb.InviteFirstCustomerRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.InviteFirstCustomerResponse>;

  inviteFirstCustomer(
    request: console_pb.InviteFirstCustomerRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.InviteFirstCustomerResponse) => void): grpcWeb.ClientReadableStream<console_pb.InviteFirstCustomerResponse>;

  inviteFirstCustomer(
    request: console_pb.InviteFirstCustomerRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.InviteFirstCustomerResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/InviteFirstCustomer',
        request,
        metadata || {},
        this.methodDescriptorInviteFirstCustomer,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/InviteFirstCustomer',
    request,
    metadata || {},
    this.methodDescriptorInviteFirstCustomer);
  }

  methodDescriptorListMembers = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListMembers',
    grpcWeb.MethodType.UNARY,
    console_pb.ListMembersRequest,
    console_pb.ListMembersResponse,
    (request: console_pb.ListMembersRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListMembersResponse.deserializeBinary
  );

  listMembers(
    request: console_pb.ListMembersRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListMembersResponse>;

  listMembers(
    request: console_pb.ListMembersRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListMembersResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListMembersResponse>;

  listMembers(
    request: console_pb.ListMembersRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListMembersResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListMembers',
        request,
        metadata || {},
        this.methodDescriptorListMembers,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListMembers',
    request,
    metadata || {},
    this.methodDescriptorListMembers);
  }

  methodDescriptorRemoveMember = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/RemoveMember',
    grpcWeb.MethodType.UNARY,
    console_pb.RemoveMemberRequest,
    console_pb.RemoveMemberResponse,
    (request: console_pb.RemoveMemberRequest) => {
      return request.serializeBinary();
    },
    console_pb.RemoveMemberResponse.deserializeBinary
  );

  removeMember(
    request: console_pb.RemoveMemberRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.RemoveMemberResponse>;

  removeMember(
    request: console_pb.RemoveMemberRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.RemoveMemberResponse) => void): grpcWeb.ClientReadableStream<console_pb.RemoveMemberResponse>;

  removeMember(
    request: console_pb.RemoveMemberRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.RemoveMemberResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/RemoveMember',
        request,
        metadata || {},
        this.methodDescriptorRemoveMember,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/RemoveMember',
    request,
    metadata || {},
    this.methodDescriptorRemoveMember);
  }

  methodDescriptorSetMemberRole = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/SetMemberRole',
    grpcWeb.MethodType.UNARY,
    console_pb.SetMemberRoleRequest,
    console_pb.SetMemberRoleResponse,
    (request: console_pb.SetMemberRoleRequest) => {
      return request.serializeBinary();
    },
    console_pb.SetMemberRoleResponse.deserializeBinary
  );

  setMemberRole(
    request: console_pb.SetMemberRoleRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.SetMemberRoleResponse>;

  setMemberRole(
    request: console_pb.SetMemberRoleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.SetMemberRoleResponse) => void): grpcWeb.ClientReadableStream<console_pb.SetMemberRoleResponse>;

  setMemberRole(
    request: console_pb.SetMemberRoleRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.SetMemberRoleResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/SetMemberRole',
        request,
        metadata || {},
        this.methodDescriptorSetMemberRole,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/SetMemberRole',
    request,
    metadata || {},
    this.methodDescriptorSetMemberRole);
  }

  methodDescriptorAcceptInvite = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/AcceptInvite',
    grpcWeb.MethodType.UNARY,
    console_pb.AcceptInviteRequest,
    console_pb.AcceptInviteResponse,
    (request: console_pb.AcceptInviteRequest) => {
      return request.serializeBinary();
    },
    console_pb.AcceptInviteResponse.deserializeBinary
  );

  acceptInvite(
    request: console_pb.AcceptInviteRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.AcceptInviteResponse>;

  acceptInvite(
    request: console_pb.AcceptInviteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.AcceptInviteResponse) => void): grpcWeb.ClientReadableStream<console_pb.AcceptInviteResponse>;

  acceptInvite(
    request: console_pb.AcceptInviteRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.AcceptInviteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/AcceptInvite',
        request,
        metadata || {},
        this.methodDescriptorAcceptInvite,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/AcceptInvite',
    request,
    metadata || {},
    this.methodDescriptorAcceptInvite);
  }

  methodDescriptorRequestSeatChange = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/RequestSeatChange',
    grpcWeb.MethodType.UNARY,
    console_pb.RequestSeatChangeRequest,
    console_pb.RequestSeatChangeResponse,
    (request: console_pb.RequestSeatChangeRequest) => {
      return request.serializeBinary();
    },
    console_pb.RequestSeatChangeResponse.deserializeBinary
  );

  requestSeatChange(
    request: console_pb.RequestSeatChangeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.RequestSeatChangeResponse>;

  requestSeatChange(
    request: console_pb.RequestSeatChangeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.RequestSeatChangeResponse) => void): grpcWeb.ClientReadableStream<console_pb.RequestSeatChangeResponse>;

  requestSeatChange(
    request: console_pb.RequestSeatChangeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.RequestSeatChangeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/RequestSeatChange',
        request,
        metadata || {},
        this.methodDescriptorRequestSeatChange,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/RequestSeatChange',
    request,
    metadata || {},
    this.methodDescriptorRequestSeatChange);
  }

  methodDescriptorRequestCancellation = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/RequestCancellation',
    grpcWeb.MethodType.UNARY,
    console_pb.RequestCancellationRequest,
    console_pb.RequestCancellationResponse,
    (request: console_pb.RequestCancellationRequest) => {
      return request.serializeBinary();
    },
    console_pb.RequestCancellationResponse.deserializeBinary
  );

  requestCancellation(
    request: console_pb.RequestCancellationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.RequestCancellationResponse>;

  requestCancellation(
    request: console_pb.RequestCancellationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.RequestCancellationResponse) => void): grpcWeb.ClientReadableStream<console_pb.RequestCancellationResponse>;

  requestCancellation(
    request: console_pb.RequestCancellationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.RequestCancellationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/RequestCancellation',
        request,
        metadata || {},
        this.methodDescriptorRequestCancellation,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/RequestCancellation',
    request,
    metadata || {},
    this.methodDescriptorRequestCancellation);
  }

  methodDescriptorListCustomerRequests = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListCustomerRequests',
    grpcWeb.MethodType.UNARY,
    console_pb.ListCustomerRequestsRequest,
    console_pb.ListCustomerRequestsResponse,
    (request: console_pb.ListCustomerRequestsRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListCustomerRequestsResponse.deserializeBinary
  );

  listCustomerRequests(
    request: console_pb.ListCustomerRequestsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListCustomerRequestsResponse>;

  listCustomerRequests(
    request: console_pb.ListCustomerRequestsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListCustomerRequestsResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListCustomerRequestsResponse>;

  listCustomerRequests(
    request: console_pb.ListCustomerRequestsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListCustomerRequestsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListCustomerRequests',
        request,
        metadata || {},
        this.methodDescriptorListCustomerRequests,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListCustomerRequests',
    request,
    metadata || {},
    this.methodDescriptorListCustomerRequests);
  }

  methodDescriptorAcknowledgeCustomerRequest = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/AcknowledgeCustomerRequest',
    grpcWeb.MethodType.UNARY,
    console_pb.AcknowledgeCustomerRequestRequest,
    console_pb.AcknowledgeCustomerRequestResponse,
    (request: console_pb.AcknowledgeCustomerRequestRequest) => {
      return request.serializeBinary();
    },
    console_pb.AcknowledgeCustomerRequestResponse.deserializeBinary
  );

  acknowledgeCustomerRequest(
    request: console_pb.AcknowledgeCustomerRequestRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.AcknowledgeCustomerRequestResponse>;

  acknowledgeCustomerRequest(
    request: console_pb.AcknowledgeCustomerRequestRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.AcknowledgeCustomerRequestResponse) => void): grpcWeb.ClientReadableStream<console_pb.AcknowledgeCustomerRequestResponse>;

  acknowledgeCustomerRequest(
    request: console_pb.AcknowledgeCustomerRequestRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.AcknowledgeCustomerRequestResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/AcknowledgeCustomerRequest',
        request,
        metadata || {},
        this.methodDescriptorAcknowledgeCustomerRequest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/AcknowledgeCustomerRequest',
    request,
    metadata || {},
    this.methodDescriptorAcknowledgeCustomerRequest);
  }

  methodDescriptorResolveCustomerRequest = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ResolveCustomerRequest',
    grpcWeb.MethodType.UNARY,
    console_pb.ResolveCustomerRequestRequest,
    console_pb.ResolveCustomerRequestResponse,
    (request: console_pb.ResolveCustomerRequestRequest) => {
      return request.serializeBinary();
    },
    console_pb.ResolveCustomerRequestResponse.deserializeBinary
  );

  resolveCustomerRequest(
    request: console_pb.ResolveCustomerRequestRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ResolveCustomerRequestResponse>;

  resolveCustomerRequest(
    request: console_pb.ResolveCustomerRequestRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ResolveCustomerRequestResponse) => void): grpcWeb.ClientReadableStream<console_pb.ResolveCustomerRequestResponse>;

  resolveCustomerRequest(
    request: console_pb.ResolveCustomerRequestRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ResolveCustomerRequestResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ResolveCustomerRequest',
        request,
        metadata || {},
        this.methodDescriptorResolveCustomerRequest,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ResolveCustomerRequest',
    request,
    metadata || {},
    this.methodDescriptorResolveCustomerRequest);
  }

  methodDescriptorListMyOrgBillingPortals = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/ListMyOrgBillingPortals',
    grpcWeb.MethodType.UNARY,
    console_pb.ListMyOrgBillingPortalsRequest,
    console_pb.ListMyOrgBillingPortalsResponse,
    (request: console_pb.ListMyOrgBillingPortalsRequest) => {
      return request.serializeBinary();
    },
    console_pb.ListMyOrgBillingPortalsResponse.deserializeBinary
  );

  listMyOrgBillingPortals(
    request: console_pb.ListMyOrgBillingPortalsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.ListMyOrgBillingPortalsResponse>;

  listMyOrgBillingPortals(
    request: console_pb.ListMyOrgBillingPortalsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.ListMyOrgBillingPortalsResponse) => void): grpcWeb.ClientReadableStream<console_pb.ListMyOrgBillingPortalsResponse>;

  listMyOrgBillingPortals(
    request: console_pb.ListMyOrgBillingPortalsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.ListMyOrgBillingPortalsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/ListMyOrgBillingPortals',
        request,
        metadata || {},
        this.methodDescriptorListMyOrgBillingPortals,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/ListMyOrgBillingPortals',
    request,
    metadata || {},
    this.methodDescriptorListMyOrgBillingPortals);
  }

  methodDescriptorRequestSupport = new grpcWeb.MethodDescriptor(
    '/atfai.console.v1.ConsoleService/RequestSupport',
    grpcWeb.MethodType.UNARY,
    console_pb.RequestSupportRequest,
    console_pb.RequestSupportResponse,
    (request: console_pb.RequestSupportRequest) => {
      return request.serializeBinary();
    },
    console_pb.RequestSupportResponse.deserializeBinary
  );

  requestSupport(
    request: console_pb.RequestSupportRequest,
    metadata?: grpcWeb.Metadata | null): Promise<console_pb.RequestSupportResponse>;

  requestSupport(
    request: console_pb.RequestSupportRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: console_pb.RequestSupportResponse) => void): grpcWeb.ClientReadableStream<console_pb.RequestSupportResponse>;

  requestSupport(
    request: console_pb.RequestSupportRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: console_pb.RequestSupportResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/atfai.console.v1.ConsoleService/RequestSupport',
        request,
        metadata || {},
        this.methodDescriptorRequestSupport,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/atfai.console.v1.ConsoleService/RequestSupport',
    request,
    metadata || {},
    this.methodDescriptorRequestSupport);
  }

}

